import { cn } from '@app/utils/cn';
import React from 'react';

import { HelpOutline } from '../Icons';
import { Popover } from '../Popover';

interface Props extends Omit<React.ComponentProps<typeof Popover>, 'content'> {
  color?: 'gray' | 'light-gray';
}

export const Help = ({ children, className, color = 'light-gray', ...tooltipProps }: React.WithChildren<Props>) => (
  <Popover {...tooltipProps} content={children} className={className}>
    <HelpOutline
      className={cn('size-4 cursor-pointer', {
        'text-neutral-40': color === 'gray',
        'text-neutral-60': color === 'light-gray',
      })}
    />
  </Popover>
);
